module.exports = __webpack_public_path__ + "static/media/nav_arrow_left.9eef9b5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nav_arrow_left.svg
// module id = 408
// module chunks = 3